import React from 'react';
import "./Merci.css";

const Merci = () => {
  return (
    <div className="merci-container">
      <h1> Merci pour votre réservation</h1>
      <p>Nous vous contacterons très bientôt pour confirmer votre trajet.</p>
    </div>
  );
};

export default Merci;
